import { CUSTOM_FIELD_TYPE_INFO } from './constants';

export type TipConfig = {
  type: 'info' | 'warning' | 'error' | 'success';
  description: string;
};

export const getCustomFieldTypeTip = (metaFieldType?: string | null): TipConfig | undefined => {
  if (!metaFieldType) return undefined;

  const info = (CUSTOM_FIELD_TYPE_INFO as Record<string, { description?: string } | undefined>)?.[metaFieldType];
  if (!info?.description) return undefined;

  return { type: 'info', description: info.description };
};

export const resolveTipDescription = <TValues>(description: string | ((values: TValues) => string) | undefined, values: TValues): string => {
  if (typeof description === 'function') return description(values) || '';
  return description || '';
};
